import React, { useEffect, useState } from "react";
import "./reportList.scss";
import { Table, Button, Popover, Menu, Tooltip } from "antd";
import { EditOutlined, DownloadOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Report } from "../../models/Report/report.model";
import ReportService from "../../services/Report/report.service";
import landingImage from "../../assets/images/radiolinq_app_landing.webp";
import { AppRoutes } from "../../routes/routeConstants/appRoutes";

function CreateReportPage() {
  const [reports, setReports] = useState<Report[]>([]);
  
  const [newReportLoading, setNewReportLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    ReportService.fetchDirectReports((reports: Report[]) => {
      setReports(reports);
    }, () => {

    }, () => {

    });
  }, []);

  useEffect(() => {
    const header = document.querySelector(".app-header") as HTMLElement;
    const appWrapper = document.querySelector(".app-wrapper.collapsed") as HTMLElement;
    if (header) {
      header.style.display = "none";
    }
    if(appWrapper) {
      appWrapper.style.margin = '0px';
    }
    setTimeout(() => {
      const appNewHeader = document.querySelector(".app-new-header") as HTMLElement;
      if(appNewHeader) {
        appNewHeader.style.display = "none";
      }
    }, 0);
  }, [history.location.pathname]);

  useEffect(() => {
    const header = (document.querySelector(".app-header") as HTMLElement);
    const appNewHeader = (document.querySelector(".app-new-header") as HTMLElement);
    const appWrapper = document.querySelector(".app-wrapper.collapsed") as HTMLElement;
    return () => {
      if (header) {
        header.style.display = "";
      }
      if(appNewHeader) {
        appNewHeader.style.display = "";
      }
      if(appWrapper) {
        appWrapper.style.margin = "";
      }
    };
  }, []);

  const handleAddNewReport = () => {
    const report = new Report();
    report.content = '';
    report.aiPlugin = true;
    setNewReportLoading(true);
    ReportService.createReport(
      report,
      (report: Report) => {
        const url = history.createHref({ pathname: AppRoutes.REPORTS_LIST + '/' + report?.id });
        window.open(url, "_blank");
      },
      () => {},
      () => {
        setNewReportLoading(false);
      }
    );
  };

  return (
    <div className="report-list">
      <div className="report-list__logo-section">
        <img
          src={landingImage}
          alt="Radiolinq Login"
          className="report-list__landing-image"
        />
      </div>
      <div className="report-list__auth-section">
        <div className="report-list__button-wrapper">
          <h2>Welcome to Radiolinq AI assist</h2>
          <div>
            <Button type="primary"
              onClick={handleAddNewReport}
              icon={<PlusOutlined/>}
              loading={newReportLoading}
              disabled={newReportLoading}
            >
              Create New Report
            </Button>
          </div>
        </div>
      </div>
      {/* <Table
        dataSource={reports}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={false}
        onRow={(record) => ({
          onClick: () => {
            // history.push(`/report/${record.id}`)
          },
          style: { cursor: "pointer" },
        })}
      /> */}
    </div>
  );
}

export default CreateReportPage;
